import { tv } from '@change/ds-utils';

export const BodyStyles = tv({
	base: 'flex flex-col bg-background-base',
	variants: {
		size: {
			xsmall: 'h-full w-full',
			small: 'w-full gap-1',
			medium: 'w-full gap-2.5',
			large: 'w-full gap-3',
		},
	},
});

export const BodyTextStyles = tv({
	base: 'tracking-0 whitespace-pre-wrap font-[Arial] leading-[140%]',
	variants: {
		size: {
			xsmall: 'line-clamp-[19] px-[5px] text-[5px]',
			small: 'line-clamp-[19] px-[5px] text-[5px]',
			medium: 'line-clamp-[19] px-2.5 text-[10px]',
			large: 'line-clamp-[18] px-3 text-[12px]',
		},
	},
});

export const BodyImageStyles = tv({
	base: 'object-fill',
	variants: {
		size: {
			xsmall: 'h-[53px] w-full',
			small: 'h-[53px] w-full',
			medium: 'h-[105px] w-full',
			large: 'h-[105px] w-full',
		},
	},
});
